import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// State
import { setError } from '../../state/modules/errors/actions';

// Components
import Modal from '../Modal';

// Styles
import styles from './Card3ds.styl';

const cx = classNames.bind(styles);

export default function Card3ds(props) {
  const { auth3dsData, orderId, callbackAfter3ds, onClose, isOpen } = props;

  const cityId = useSelector(state => state.city.userCity.id);
  const locale = useSelector(state => state.intl.locale);

  const [modalIsLoaded, setModalIsLoaded] = useState(false);

  const hideModal = () => {
    onClose();
  };

  const modalOnLoad = () => {
    setModalIsLoaded(true);
  };

  const auth3DsCallback = e => {
    if (e.data.error) {
      hideModal();
      setError(e.data.error);
      return;
    }

    if (e.data.transaction_status) {
      hideModal();
      callbackAfter3ds();
    }
  };

  const formPostRequest = (action, fields) => {
    const form = document.createElement('form');
    form.setAttribute('target', '3dsiframe');
    form.setAttribute('action', action);
    form.setAttribute('method', 'post');

    Object.keys(fields).map(field => {
      const input = document.createElement('input');
      input.setAttribute('name', field);
      input.setAttribute('value', fields[field]);
      input.setAttribute('hidden', true);
      return form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };

  useEffect(() => {
    if (isOpen) {
      window.addEventListener('message', auth3DsCallback);

      // звучит странно, но если завернуть в setTimeout, то форма откроется в фрейме, а не в отдельной ссылке
      setTimeout(() => {
        formPostRequest(auth3dsData.acs_url, {
          PaReq: auth3dsData.pa_req,
          MD: auth3dsData.md,
          TermUrl: `${window.location.origin}/online-payment?lang=${locale}&order_id=${orderId}&city_id=${cityId}`,
        });
      }, 0);
    }

    return () => {
      if (isOpen) {
        window.removeEventListener('message', auth3DsCallback);
      }
    };
  }, [isOpen]);

  return (
    <Modal className={cx('Card3ds__modal')} direction="left" isOpen={isOpen} onClose={hideModal}>
      <div className={cx('Card3ds__loader')}>
        <div className={cx('Card3ds__spinner')} />
      </div>
      <iframe
        className={cx('Card3ds__iframe', {
          Card3ds__iframe_isLoaded: modalIsLoaded,
        })}
        id="ds3iframe"
        name="3dsiframe"
        title="3dsiframe"
        frameBorder="0"
        onLoad={modalOnLoad}
      />
    </Modal>
  );
}

Card3ds.defaultProps = {
  orderId: undefined,
  callbackAfter3ds: () => null,
  onClose: () => null,
  isOpen: false,
  auth3dsData: undefined,
};

Card3ds.propTypes = {
  auth3dsData: PropTypes.object,
  orderId: PropTypes.number,
  callbackAfter3ds: PropTypes.func,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
};
